<template>
<div class="chapter">
<div class="inner_page">
<p class="imgcenter"><img alt="images" src="images/img10.jpg"/></p>
<p class="caption"><em class="italic">Ordnance Survey Map of Old Basford, c.1890. </em><span class="caption1">Nottingham City Library</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05a_FOULDEEDSNOTTINGHAM_CHAPTER01.vue?57805034